import { useMutation, useQueryClient } from "@tanstack/react-query";
import collectionApiClient from "../../../api/collection";

const useCreateCollectionCodeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      collectionId,
      orderName,
      multiUse,
      expiresAt,
    }: {
      collectionId: string;
      orderName: string;
      multiUse?: boolean;
      expiresAt?: Date;
    }) =>
      collectionApiClient.createCollectionCode(
        collectionId,
        orderName,
        multiUse,
        expiresAt,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["collectionCodes"] });
    },
  });
};

export default useCreateCollectionCodeMutation;
